import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Hero from '@/components/Hero'
import Summary from '@/components/Summary'
import { Columns } from '@/components/Article/style.css'
import { Content } from '@/components/Rankings/style.css'
import { Link } from 'gatsby'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Ranking de universidades chilenas en el extranjero"
      keywords={[
        `La Tercera`,
        `Ranking Universidades chilenas en el extranjero`,
        `Ranking Universidades`,
      ]}
    />
    <Hero />
    <Summary />

    <div className="container mx-auto max-w-5xl">
      <Content>
        <h1 className="text-center">
          <strong>Investigación y prestigio son clave</strong>
        </h1>
        <p className="excerpt text-2xl mb-6 ">
          Cada ranking define un concepto de universidades basado en indicadores
          estandarizados que dan cuenta de qué miden, cómo lo miden y qué
          entienden por calidad.
        </p>
        <Columns>
          <p>
            Si bien el desempeño de una universidad en un ranking responde a un
            conjunto de variables, hay algunas que tienen un mayor peso
            porcentual y que dan cuenta de la posición alcanzada. Prestigio e
            investigación son los pilares que tienen en común los rankings
            Academic Ranking of World Universities (ARWU), QS World University
            Rankings y THE World University Rankings. Para ARWU el prestigio
            viene dado por los reconocimientos internacionales de sus académicos
            y exalumnos, mientras que las encuestas de reputación son utilizadas
            por QS y THE. En tanto, la investigación responde a dos nociones:
            productividad e impacto.
          </p>

          <p>
            Pese a tener indicadores comunes, cada ranking enfatiza un aspecto,
            entregando una ponderación mayor a aquella característica
            considerada clave para discriminar cuáles son las universidades de
            excelencia. ARWU establece un peso de 70 % a la investigación, QS un
            50 % al prestigio, y THE un 33 % al prestigio y un 30 % a las citas.
          </p>
          <p>
            En cuanto a los indicadores empleados, ARWU no considera indicadores
            subjetivos —como QS y THE—, ni asociados a la docencia y solo
            utiliza bases de datos públicas como fuentes de la información. El
            ranking QS, en cambio, usa los resultados de las encuestas a 130 mil
            académicos y 75 mil empleadores a nivel mundial, el análisis de más
            de 13 millones de papers indexados a Scopus y las cifras de
            profesores y estudiantes que les entregan, a través de
            cuestionarios, las propias universidades. De igual forma, THE
            trabaja con Scopus —las universidades deben tener como mínimo 1.000
            publicaciones en los últimos cinco años—, encuestas de reputación
            académica e información entregada por las casas de estudio.
          </p>
          <p>
            Por otra parte, si bien los factores o pilares con los que cada
            ranking mide la calidad de las instituciones tienen en común la
            investigación y el cuerpo académico, difieren en los indicadores
            considerados para construir ese factor. Así, ARWU utiliza los
            reconocimientos internacionales obtenidos por académicos (premios
            Nobel y medallas Fields) para calificar a los académicos, QS deja de
            lado los premios y apunta a la reputación y al número de alumnos que
            hay por profesor, THE hace lo mismo (encuesta y razón de alumnos por
            profesor), pero suma los ingresos institucionales por profesor.
            Respecto de los indicadores de calidad de la investigación, los tres
            rankings utilizan el de productividad, basado en el número de
            publicaciones por profesor.
          </p>
        </Columns>
      </Content>
    </div>
  </Layout>
)

export default IndexPage
